import React, { useState } from "react";
import { Spacer } from "../../spacer";
import { PortalBillBreakdownModal } from "./portal_bill_breakdown_modal";
import { ManageMembershipDetailsContent } from "./manage_membership_details_content";
import { useSubscriptionDetailsQuery } from "../hooks/use_subscription_details_query";
import { useParams } from "react-router-dom";
import { PortalPathParams } from "../hooks/use_portal_history";
import { useUpcomingPaymentQuery } from "../hooks/use_upcoming_payment_query";
import { useMembershipChargesQuery } from "../hooks/use_membership_charges_query";

interface ManageMembershipDetailsProps {
  partnerId: string;
}

export function ManageMembershipDetails({
  partnerId,
}: ManageMembershipDetailsProps) {
  const { subscriptionId } = useParams<PortalPathParams>();

  const { data: subscriptionDetailsData } = useSubscriptionDetailsQuery(
    partnerId,
    subscriptionId
  );
  const { data: upcomingPaymentData } = useUpcomingPaymentQuery(
    partnerId,
    subscriptionId
  );
  const { data: chargesData } = useMembershipChargesQuery(
    partnerId,
    subscriptionId
  );
  const isSubscriptionCancelled =
    subscriptionDetailsData?.status === "canceled";
  const bill = isSubscriptionCancelled
    ? chargesData?.find((c) => c.transactionType === "charge")
    : upcomingPaymentData;

  const [openMembershipBillBreakdown, setOpenMembershipBillBreakdown] =
    useState(false);

  return (
    <div>
      <div className="fw-bold fs-3">Membership details</div>
      <Spacer size={20} />
      {subscriptionDetailsData && (
        <div>
          <ManageMembershipDetailsContent
            startDate={subscriptionDetailsData.startDate}
            billDate={bill?.paymentDate}
            billTotal={bill?.totalPrice}
            endDate={subscriptionDetailsData.endDate}
            currency={bill?.currency}
            cancellationDate={subscriptionDetailsData.cancellationDate}
            isCancelled={subscriptionDetailsData.status === "canceled"}
            onClickDetails={() => setOpenMembershipBillBreakdown(true)}
          />
          {bill && (
            <PortalBillBreakdownModal
              show={openMembershipBillBreakdown}
              onHide={() => setOpenMembershipBillBreakdown(false)}
              totalAmount={bill.totalPrice}
              monthlyPaymentAmount={bill.unitPrice}
              currency={bill.currency}
              taxAmount={bill.taxAmount}
              taxDescription={bill.taxDescription}
              promotionAmount={bill.promotionAmount}
              promotionCode={bill.promotionCode}
              paymentCycles={bill.paymentCycles - 1}
              adjustmentAmount={bill.adjustmentAmount}
              feeLines={bill.feeLines}
            />
          )}
        </div>
      )}
    </div>
  );
}
